/* eslint-disable import/prefer-default-export */
const tabs = ['Latest Session', 'Last 7 Days', 'Last 30 Days'];

/** General Settings Side Bar Nav Link info */
const generalSettingsSideBarNavArrayOfObjects = [
  { routeName: '/settings', text: 'General', icon: 'user' },
  { routeName: '/settings/account', text: 'Account Settings', icon: 'user' },
  { routeName: '/settings/organization', text: 'Organization Settings', icon: 'group-alt' },
  { routeName: '/settings/subscriptions', text: 'Subscriptions', icon: 'credit-card' },
  { routeName: '/settings/tactical', text: 'Enhanced Security (Tactical) Settings', icon: 'lock' },
  { routeName: '/settings/integrations', text: 'Integrations', icon: 'swap' },
  { routeName: '/teambuildr-os', text: 'TeamBuildr OS', icon: 'os' },
];

const EXERCISE_TYPE = {
  Circuit: 'C',
  Circuits: 'C',
  Cooldown: 'CD',
  Deleted: 'DEL', // This is a special type for deleted exercises - it should not be returned in any API calls.
  Health: 'H',
  Lift: 'L',
  Lifts: 'L',
  Note: 'N',
  Progression: 'P',
  Question: 'Q',
  Questionnaire: 'S',
  Rest: 'RT',
  RunCardio: 'R',
  SAQC: 'R',
  SessionBreak: 'BR',
  Tag: 'T',
  Video: 'V',
  WarmUp: 'W',
};

const SUPERSET_DEFAULTS = {
  A: '#00d68b',
  B: '#0ab3cd',
  C: '#f36dab',
  D: '#e6c82b',
  E: '#f3a96d',
  F: '#f3716d',
  G: '#6de1f3',
  H: '#c389f5',
  I: '#f5898b',
  J: '#00d68b',
  K: '#0ab3cd',
  L: '#f36dab',
  M: '#e6c82b',
  N: '#f3a96d',
  O: '#f3716d',
  P: '#6de1f3',
  Q: '#c389f5',
  R: '#f5898b',
  S: '#00d68b',
  T: '#0ab3cd',
  U: '#f36dab',
  V: '#e6c82b',
  W: '#f3a96d',
  X: '#f3716d',
  Y: '#6de1f3',
  Z: '#c389f5',
};

const calendarIcons = {
  questionnaire: {
    name: 'Questionnaire',
    id: 'Questionnaire',
    type: 'S',
    icon: 'question-mark-circle',
    iconColor: '#9B59B6',
    containerColor: 'rgba(155, 89, 182, 0.2)',
  },
  'warm-up': {
    name: 'Warm-Up',
    id: 'Warm-Up',
    type: 'W',
    icon: 'warmup',
    iconColor: '#E74C3C',
    containerColor: 'rgba(231, 76, 60, 0.2)',
  },
  lift: {
    name: 'Lift',
    id: 'Lift',
    type: 'L',
    icon: 'lift',
    iconColor: '#6C7A89',
    containerColor: 'rgba(108, 122, 137, 0.2)',
  },
  cardio: {
    name: 'SAQ+C',
    id: 'SAQ+C',
    type: 'R',
    icon: 'cardio',
    iconColor: '#59ABE3',
    containerColor: 'rgba(89, 171, 227, 0.2)',
  },
  circuit: {
    name: 'Circuit',
    id: 'Circuit',
    type: 'C',
    icon: 'circuit',
    iconColor: '#F89406',
    containerColor: 'rgba(248, 148, 6, 0.2)',
  },
  'cool-down': {
    name: 'Cooldown',
    id: 'Cooldown',
    type: 'CD',
    icon: 'cooldown',
    iconColor: '#1787FB',
    containerColor: 'rgba(23, 135, 251, 0.2)',
  },
  health: {
    name: 'Health',
    id: 'Health',
    type: 'H',
    icon: 'heart',
    iconColor: '#E74C3C',
    containerColor: 'rgba(231, 76, 60, 0.2)',
  },
  science: {
    name: 'Health',
    id: 'Health',
    type: 'H',
    icon: 'heart',
    iconColor: '#E74C3C',
    containerColor: 'rgba(231, 76, 60, 0.2)',
  },
  break: {
    name: 'Session Break',
    id: 'Session Break',
    type: 'BR',
    /** need to add new icon here */
    icon: 'break',
    iconColor: '#000000',
    containerColor: 'rgba(68, 68, 68, 0.2)',
  },
  note: {
    name: 'Notes',
    id: 'Notes',
    type: 'N',
    icon: 'note',
    iconColor: '#F9BF3B',
    containerColor: 'rgba(249, 191, 59, 0.2)',
  },
  resttime: {
    name: 'Rest Time',
    id: 'Rest Time',
    type: 'RT',
    icon: 'clock',
    iconColor: '#26C281',
    containerColor: 'rgba(38, 194, 129, 0.2)',
  },
  progression: {
    name: 'Progressions',
    id: 'Progressions',
    type: 'P',
    icon: 'chart',
    iconColor: '#FF00BF',
    containerColor: 'rgba(255, 0, 191, 0.2)',
  },
  video: {
    name: 'Video',
    id: 'Video',
    type: 'V',
    icon: 'video-add',
    iconColor: '#444444',
    containerColor: 'rgba(68, 68, 68, 0.2)',
  },
  tag: {
    name: 'Tags',
    id: 'Tags',
    type: 'T',
    icon: 'tag2',
    iconColor: '#FF4500',
    containerColor: 'rgba(255, 69, 0, 0.2)',
  },
};

/** Map of deprecated superset colors to their updated values */
const SUPERSET_COLOR_MIGRATIONS = {
  '#f3ea6d': '#e6c82b',
};

/** Returns the current color for a superset, migrating old backend values if needed */
const normalizeSupersetColor = (color) => {
  if (!color) return color;
  const lower = color.toLowerCase();
  return SUPERSET_COLOR_MIGRATIONS[lower] || color;
};

export {
  tabs,
  generalSettingsSideBarNavArrayOfObjects,
  EXERCISE_TYPE,
  calendarIcons,
  SUPERSET_DEFAULTS,
  normalizeSupersetColor,
};
